import SColors from '../../styles/colors'
import { SStyled } from '../../styles/theme'
import SFlex from '../opinionless/SFlex'
import SPage from '../opinionless/SPage'

export const input = {
    borderColor: {
        default: '#CCCCCC',
        hover: '#CCCCCC',
        error: SColors.RedError,
    },
}

export const error = {
    color: SColors.RedError,
}

export const radio = {
    color: {
        unselected: SColors.GrayUnselectedRadioOutline,
    },
}

export const readOnlyStyles = (theme) => {
    return {
        backgroundColor: theme.colors.gray125,
        color: theme.colors.gray350,
    }
}

export const FContentContainer = SStyled(SFlex)`
    width: 100%;
    max-width: 600px;
    padding: 0px;
    flex-direction: column;
    align-items: center;

    ${(p) => `
        @media screen and (max-width: ${p.theme.breakpoints[0]}) {
            padding: 0px;
        }
    `}
`

export const FPage = SStyled(SPage)`
    padding: 100px 160px;
    display: flex;
    justify-content: center;
    padding-top: 0px;

    ${(p) => `
        @media screen and (max-width: ${p.theme.breakpoints[0]}) {
            padding: 24px;
        }
    `}
`
